import React from 'react';

import { FlexLayout } from '@zapier/common-components';
import CommonDismiss from 'app/developer-v3/components/Dismiss';

import { JobsCta } from '../JobsCta';

import {
  Props as ShouldRenderProps,
  useShouldRender,
} from './hooks/useShouldRender';

import { useData as _useData } from './hooks/useData';

type Props = {
  /** For dependency injection testing only */
  useData?: () => ReturnType<typeof _useData>;
};

const DismissibleJobsCta = ({ useData = _useData }: Props = {}) => {
  const { dismissJobsCta, isLoading, profileId } = useData();

  return isLoading ? null : (
    <FlexLayout justify="flex-end">
      <JobsCta />

      {!!profileId && (
        <CommonDismiss
          aria-label="Close Top Bar"
          iconSize={10}
          onDismiss={dismissJobsCta}
        />
      )}
    </FlexLayout>
  );
};

DismissibleJobsCta.shouldRender = (props: ShouldRenderProps = {}) =>
  useShouldRender.call(this, props);

export { DismissibleJobsCta };
